import { css } from '@rxdi/lit-html';

const iconStyles = css`
  :host {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-height: 100%;
  }
  svg {
    width: auto;
    max-height: 100%;
  }
`;

export default iconStyles;
